import type {
  HomepageVideo,
  HomepageVideoById,
  HomepageVideoState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageVideo';

export const getAll = (state: HomepageVideoState): HomepageVideoById => state.byId;
export const get = (state: HomepageVideoState, id: string): HomepageVideo => state.byId[id];
